import { ChangeEventHandler } from 'react'

import { Input, OnChange, Select } from '@/components'
import {
  tariffModalityOptions,
  UCGroupOptions,
  UCSubGroupOptions
} from '@/components/Form/Form.data'

import { ConsumerUnitFieldsProps } from './ConsumerUnit.type'

const ConsumerUnitFields = ({
  formData,
  onChange,
  id,
  index,
  clearUcData,
  hidden
}: ConsumerUnitFieldsProps) => (
  <div className={hidden ? 'hidden' : 'visible'}>
    <div className="my-4 flex flex-col gap-4 rounded-md border border-teal-200 bg-zinc-50 p-4">
      {formData?.ucs && (
        <>
          <Input
            label={`Unidade Consumidora (${id})`}
            placeholder="Digite o número de instalação (UC)"
            value={formData?.ucs[`Cliente_UC${id}`]}
            onChange={onChange as OnChange}
            name={`Cliente_UC${id}`}
            size="sm"
          />

          <Input
            label={`Consumo Médio a Compensar (kWh) (${id})`}
            type="number"
            placeholder="Digite o Consumo Médio (somente números)"
            value={formData?.ucs[`Cliente_CM${id}`]}
            onChange={onChange as OnChange}
            name={`Cliente_CM${id}`}
            size="sm"
          />

          <Select
            hidden
            name={`Cliente_Grupo${id}`}
            label="Grupo"
            size="sm"
            // selectedValue={formData?.ucs[`Cliente_Grupo${id}`] ?? ''}
            selectedValue="BT"
            options={UCGroupOptions}
            onChange={onChange as ChangeEventHandler<HTMLSelectElement>}
          />

          <div className="-mt-4">
            <Select
              name={`Cliente_Subgrupo${id}`}
              label="Subgrupo"
              size="sm"
              selectedValue={formData?.ucs[`Cliente_Subgrupo${id}`] ?? ''}
              options={UCSubGroupOptions}
              onChange={onChange as ChangeEventHandler<HTMLSelectElement>}
              center={false}
            />
          </div>

          <Select
            hidden
            name={`Cliente_MT${id}`}
            size="sm"
            label={`Modalidade Tarifária (${id})`}
            // selectedValue={formData?.ucs[`Cliente_MT${id}`] ?? ''}
            selectedValue={'Convencional'}
            options={tariffModalityOptions}
            onChange={onChange as ChangeEventHandler<HTMLSelectElement>}
          />

          {/* Botão para limpar dados da UC */}
          <div className="flex justify-end">
            <button
              type="button"
              className="btn btn-error btn-xs -mt-5 text-white"
              onClick={() => clearUcData(index)} // Passa o índice da UC
            >
              Limpar Dados UC{id}
            </button>
          </div>
        </>
      )}
    </div>
  </div>
)

export default ConsumerUnitFields
